(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.vc-reveal, .vc-reveal-stagger');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vc-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('vc-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-vc-countup]');
    if (!els.length) return;
    var run = function (el) {
      var target = parseFloat(el.getAttribute('data-vc-countup')) || 0;
      var suffix = el.getAttribute('data-vc-suffix') || '';
      var duration = 1200;
      var start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            run(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initFaq() {
    var groups = document.querySelectorAll('.vc-faq');
    groups.forEach(function (group) {
      var items = group.querySelectorAll('.vc-faq-item');
      items.forEach(function (item) {
        var btn = item.querySelector('.vc-faq-q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = item.classList.contains('vc-open');
          items.forEach(function (i) { i.classList.remove('vc-open'); });
          if (!open) item.classList.add('vc-open');
        });
      });
    });
  }

  function initGallery() {
    var galleries = document.querySelectorAll('.vc-gallery');
    galleries.forEach(function (gallery) {
      var main = gallery.querySelector('.vc-gallery-main img');
      var thumbs = gallery.querySelectorAll('.vc-gallery-thumb');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full');
          if (!fullSrc) return;
          main.setAttribute('src', fullSrc);
          thumbs.forEach(function (t) { t.classList.remove('vc-active'); });
          thumb.classList.add('vc-active');
        });
      });
    });
  }

  function initVariantPicker() {
    var forms = document.querySelectorAll('[data-vc-product-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-vc-variants]');
      if (!dataEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var selects = form.querySelectorAll('[data-vc-option]');
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = form.querySelector('[data-vc-price]');
      var compareEl = form.querySelector('[data-vc-compare-price]');
      var addBtn = form.querySelector('[data-vc-add-btn]');

      function money(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        });
      }

      function currentSelection() {
        var values = [];
        selects.forEach(function (sel) { values.push(sel.value); });
        return values;
      }

      function findVariant() {
        var values = currentSelection();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === values[i]; });
        });
      }

      function update() {
        var variant = findVariant();
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl && variant.price != null) priceEl.textContent = money(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = money(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-vc-label-available') || addBtn.textContent;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-vc-label-sold-out') || 'Agotado';
          }
        }
      }

      selects.forEach(function (sel) { sel.addEventListener('change', update); });
      update();
    });
  }

  function initTilt() {
    var els = document.querySelectorAll('[data-vc-tilt]');
    if (!els.length || window.matchMedia('(pointer: coarse)').matches) return;
    els.forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(800px) rotateY(0deg) rotateX(0deg)';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initFaq();
    initGallery();
    initVariantPicker();
    initTilt();
  });
})();
